export default {"src":"/_next/static/media/mail-blue.7b69ef0c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};